import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDisableCustomBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.disableCustomBadge,
  {
    mutationKey: ['disableCustomBadge'],
  },
)
